import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import Panel from '../components/Panel';
import StatCard from '../components/StatCard';
import { IconCalendar, IconTrendUp, IconPin } from '../components/icons';

export default function Events() {
  const { loading, data, live } = useApi(() => api.events());
  const series = data?.series || [];

  return (
    <>
      <Topbar title="Analyse des événements spéciaux" subtitle="Mobilité normale vs jour d'événement" live={live} />
      <div className="content">
        {loading ? <div className="loading-screen">Chargement…</div> : (
          <>
            <div className="kpi-row kpi-row--3">
              <StatCard label="Événement" value={data.evenement} icon={IconCalendar} delay={0} />
              <StatCard label="Multiplicateur de pic" value={`×${data.multiplicateur_pic}`} icon={IconTrendUp} trend={{ dir: 'up', text: 'vs jour normal' }} delay={70} />
              <StatCard label="Zone focus" value={data.zone_focus} icon={IconPin} delay={140} />
            </div>
            <Panel icon={IconCalendar} title="Flux horaire — normal vs événement" sub={data.evenement} delay={120}>
              <div className="chart-wrap">
                <ResponsiveContainer width="100%" height={260}>
                  <AreaChart data={series} margin={{ top: 8, right: 8, left: -14, bottom: 0 }}>
                    <defs>
                      <linearGradient id="ev" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#ef4444" stopOpacity={0.3} /><stop offset="100%" stopColor="#ef4444" stopOpacity={0.02} /></linearGradient>
                      <linearGradient id="nm" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#0d9488" stopOpacity={0.25} /><stop offset="100%" stopColor="#0d9488" stopOpacity={0.02} /></linearGradient>
                    </defs>
                    <CartesianGrid stroke="#eef2f6" vertical={false} />
                    <XAxis dataKey="heure" tickLine={false} axisLine={false} interval={3} tick={{ fontSize: 11 }} dy={6} />
                    <YAxis tickLine={false} axisLine={false} width={46} tick={{ fontSize: 11 }} />
                    <Tooltip />
                    <Legend wrapperStyle={{ fontSize: 12 }} />
                    <Area type="monotone" dataKey="normal" name="Jour normal" stroke="#0d9488" strokeWidth={2} fill="url(#nm)" />
                    <Area type="monotone" dataKey="evenement" name="Événement" stroke="#ef4444" strokeWidth={2.4} fill="url(#ev)" />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </Panel>
            <Panel icon={IconPin} title="Recommandations de pré-positionnement" delay={180}>
              <ul style={{ paddingLeft: 18, fontSize: 14, color: 'var(--slate-700)', lineHeight: 1.9 }}>
                {data.recommandations.map((r, i) => <li key={i}>{r}</li>)}
              </ul>
            </Panel>
          </>
        )}
      </div>
    </>
  );
}
